<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0" style="padding-bottom: 0px">

    <div class="col-sm-3">View Requests</div>

    <div class="col-sm-3">
      <mat-form-field>
        <mat-label>Current Role:</mat-label>
        <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()">
          <mat-option *ngFor="let group of userGroups" [value]="group.groupId"
          >{{group.grpName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <mat-form-field>
        <mat-label>Workspace:</mat-label>
        <mat-select [(ngModel)]="workType" (selectionChange)="onWorkTypeChange()">
          <mat-option *ngFor="let wp of workspaces" [value]="wp.id"
          >{{wp.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <ol class="breadcrumb cust-bread">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">View Request</li>
      </ol>
    </div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="col-md-3">
      <div class="views-title">
        Views
      </div>
      <div class="views-body">
        Modules
        <button class="btn btn-light" (click)="toggleViews()"><i class="fa "
                                                                 [ngClass]="displayed?'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div class="views-body" [hidden]="!displayed">
        <div class="height-40" [hidden]="ticketTypeLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <mat-radio-group (change)="onButtonChange($event)">
          <mat-radio-button *ngFor="let button of types;" [value]="button"
                            [checked]="button.checked">{{button.name}}&nbsp;</mat-radio-button>
        </mat-radio-group>
        <br>
      </div>
      <div class="views-body mar-top-15">
        Folders
        <button class="btn btn-light" (click)="toggleFolderViews()"><i class="fa "
                                                                       [ngClass]="folderDisplayed?'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div [hidden]="!folderDisplayed">
        <div class="loader-img height-120" [hidden]="folderLoaded">
          <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif">
        </div>
        <ul class="folders">
          <!--          <li *ngFor="let menu of menus;" [ngClass]="{activeF: step===menu.fid}"-->
          <!--              (click)="step=menu.fid;folderClick(step)">-->
          <!--            <i class="fa fa-filter"></i>-->
          <!--            {{menu.funcDescription}}-->
          <!--          </li>-->
          <li *ngFor="let menu of menus;" [ngClass]="{activeF: step===menu.fid}" id="menu_{{menu.fid}}"
              (click)="clickedFilter(menu.fid)">
            <i class="fa fa-filter"></i>
            {{menu.funcDescription}}
          </li>
        </ul>

        <!--<input type="text" class="form-control inline radius-0 font-13 mar-top-1" placeholder="Ticket No..">-->
        <!--<button type="button" class="btn btn-success radius-0 font-13 mar-lft-2 mar-top-1">GO</button>-->


      </div>

    </div>
    <div class="col-md-9 col-sm-12">
      <div class="card">
        <!--<div class="card-header card-header-top">-->
        <!--View Tickets-->
        <!--<div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected-->
        <!--items:<span>{{selected}}</span>)-->
        <!--</div>-->
        <!--<div class="pull-right font-13">-->
        <!--<b>Total items: </b> <span>{{totalItems}}</span>-->
        <!--</div>-->
        <!--</div>-->
        <div class="card-header card-header-top">
          <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
          </div>
          <div class="pull-right font-13">
            <select class="custom-select mr-sm-2 radius-0 font-13 custom-width" [(ngModel)]="pageSizeSelected" (change)="onPageSizeChange($event.target.selectedIndex)">
              <option *ngFor="let pageSize of pageSizeObj" [value]="pageSize.id">{{pageSize.value}}</option>
            </select>
            <button class="btn btn-primary addButton" [disabled]="previousOffset === 0" (click)="getPreviousData()"> < </button>&nbsp;
            <button class="btn btn-danger addButton" [disabled]="nextOffset === 0" (click)="getNextData()"> > </button>&nbsp;
            <span><b>Page</b> {{page_no}} <b>Of</b> {{totalPage}} &nbsp;&nbsp;<b>Total items: </b> {{totalData}}</span>
          </div>
        </div>
        <div class="card-body card-body-grid" id="viewGrid">
          <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
          <!--<ngb-pagination (pageChange)="onPager($event)" [collectionSize]="collectionSize" [(page)]="page" size="sm" [maxSize]="MAX_SIZE"-->
          <!--[rotate]="true" [disabled]='isDisabled' [boundaryLinks]="true"></ngb-pagination>-->
          <angular-slickgrid gridId="grid1"
                             [columnDefinitions]="columnDefinitions"
                             [gridOptions]="gridOptions"
                             [gridHeight]="365"
                             (onAngularGridCreated)="angularGridReady($event)"
                             (sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                             (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                             [dataset]="dataset">
          </angular-slickgrid>

        </div>
      </div>

    </div>

  </div>
</div>
<app-display-ticket-chr [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected" [groupName]="groupName"
                        [grpLevel]="grpLevel" [notifier]="notifier" [folderClicked]="folderClicked" (tabledata)="getTableData($event)"
                        [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket" (loadView)="onPageLoad()"></app-display-ticket-chr>
<notifier-container></notifier-container>
